import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { UIRouter } from '@uirouter/core';
import { IAppRouterState } from './router-state';
import { Observable } from 'rxjs';
import { getRouterState } from './router-selectors';
import { RouterGoAction, RouterGoBackAction } from './router-actions';

@Injectable()
export class RouterService {
    constructor(private router: UIRouter,
                private store$: Store<IAppRouterState>) {}

    public getCurrentState(): Observable<IAppRouterState> {
        return this.store$.select(getRouterState);
    }

    /**
     * Wrapper for UI-Router go.
     * @param {string} stateName
     * @param params
     * @param options
     */
    public go(stateName: string, params?: any, options?: any) {
        this.store$.dispatch(
            new RouterGoAction({
                name: stateName,
                params,
                options,
            })
        );
    }

    public goBack() {
        this.store$.dispatch(new RouterGoBackAction());
    }
}
